exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.likes-dropdown[data-v-facbe272] {\n    z-index: 9;\n    background-color: #fff;\n    padding-top: 5px;\n    position:absolute;\n    margin-bottom: 1rem;\n    border: none;\n    border-radius: 0.5rem;\n    box-shadow: 1px 3px 15px 0px rgba(0, 0, 0, 0.4);\n    transition: all 0.3s ease-in-out;\n}\n", ""]);

// exports
